import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import { Card, CardHeader, CardContent, CardActions, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from 'styles/components/widgetLaunches.module.scss';
import { randIndex } from 'tools/functions';
import Link from 'components/link';

const WidgetLaunches = ({ data }) => {
    const [recentModels, setRecentModels] = useState(null);
    useEffect(() => {
        // if data provided is coming from getBrandsModels
        if (data[0].models) {
            const allModels = [];
            data.forEach((brand) => {
                const mods = [...brand.models];
                mods.forEach((mod) => {
                    // eslint-disable-next-line no-param-reassign
                    mod.brand = { brand: brand.brand };
                });
                allModels.push(...mods);
            });
            const sortedModels = allModels.sort((a, b) => {
                return new Date(b.createdAt) - new Date(a.createdAt);
            });
            const randMod = randIndex(19, 6);
            setRecentModels(
                sortedModels.filter((model, ind) => {
                    return randMod.includes(ind);
                }),
            );
        } else {
            setRecentModels(data);
        }
    }, [data]);
    return (
        <div className={styles.root}>
            <Card className={styles.cardRoot}>
                <CardHeader title={<h2>Nouveautés </h2>} />
                <CardContent className={styles.cardContent}>
                    {recentModels?.map((model) => (
                        <Box key={model.model}>
                            <Link
                                href={`/modeles-voiture/${model.brand.brand.replace(
                                    / /g,
                                    '-',
                                )}/${model.model.replace(/ /g, '-')}`}
                            >
                                <Image
                                    src={`${process.env.NEXT_PUBLIC_API_HOST}/images/models/${model.images[0].filename}`}
                                    alt={model.model}
                                    width="90"
                                    height="60"
                                    layout="fixed"
                                />
                            </Link>
                            <span
                                className={styles.subtitle}
                            >{`${model.brand.brand} ${model.model}`}</span>
                        </Box>
                    ))}
                </CardContent>
                <CardActions />
            </Card>
        </div>
    );
};

WidgetLaunches.propTypes = {
    data: PropTypes.array.isRequired,
};

export default React.memo(WidgetLaunches);
